import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ProService } from '../db/models/pro-services';
import { SearchData } from '../db/models/search';
import { SearchResult } from '../db/models/search-result';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  // private baseUrl = 'https://localhost:44352/api/search/';
 private baseUrl = 'https://api.trepezserver.com/api/search/';

  private searchParams: SearchData;

  pservices: ProService[];

constructor(private http: HttpClient) { }

get SearchParams() {
  return this.searchParams
}

set SearchParams(obj: SearchData){
  this.searchParams = obj;
}

// getSearchResult(data: SearchData): Observable<SearchResult[]> {
//   return this.http.get<SearchResult[]>(this.baseUrl)
//   .pipe(
//     map(data => console.log(JSON.stringify(data)))
//     catchError(this.handleError)
//   );
// }


getSearchResults(data: SearchData): Observable<SearchResult[]> {
  let link = `${this.baseUrl}search_results`;
  let params = 'name_description=' + data.category + '&'+ 'city=' + data.city;

  if (params) {
   link += `?${params}`
  }
  return this.http.get<SearchResult[]>(link);

}




}
